import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems, Dialog } from '@headlessui/react'
import React, { useEffect, useState } from 'react';
import {useNavigate} from "react-router-dom";

type Evidencia = {
    id: number;
    imagen_path: string;
    calorias_quemadas: number;
    tiempo_ejercicio: number;
    tipo_ejercicio_evidencia: string;
    pasos: number;
    distancia_km: number;
    created_at: string;
    estatus: string;
};

type EvidenciaNueva = {
    ruta_archivo: string;
    tipo_ejercicio_evidencia: string;
    calorias_quemadas_evidencia: string;
    tiempo_evidencia: string;
    pasos_evidencia: string;
    distancia_evidencia: string;
    correo_evidencia: string;
}

type Evidencia_suma = {
    total_calorias: number;
    total_tiempo: number;
    total_pasos: number;
    total_distancia: number;
};

let usuario = JSON.parse(localStorage.getItem('usuario_data') || '{}');


function UserViewComponent() {
    const [evidencias, setEvidencias] = useState<Evidencia[]>([]);
    const [evidenciasSumas, setEvidenciasSumas] = useState<Evidencia_suma[]>([]);
    const [loading, setLoading] = useState(true);
    const [archivo, setArchivo] = useState<File | null>(null);
    const [rutaImagen, setRutaImagen] = useState('');

    const [previewImage, setPreviewImage] = useState<string | null>(null);

    const [subiendo, setSubiendo] = useState(false);

    const [formDataEvidencia, setFormDataEvidencia] = useState<EvidenciaNueva>({
        ruta_archivo: '',
        tipo_ejercicio_evidencia:'',
        calorias_quemadas_evidencia:'',
        tiempo_evidencia:'',
        pasos_evidencia:'',
        distancia_evidencia:'',
        correo_evidencia: usuario.correo,
    }
    );
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const navigate = useNavigate();

    const modalImage = (src: string) => {
        setModalImageSrc(src);
        setIsModalOpen(true);
    };

    const cerrarSesion = async () => {
        localStorage.removeItem('usuario_data'); // Borra el usuario guardado
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(cache => caches.delete(cache)));
        }
        usuario = '{}';
        sessionStorage.clear();
        localStorage.clear();
        window.scrollTo(0, 0);
        navigate('/');
    };

    const revisarEvidencias = async () => {
        window.scrollTo(0, 0);
        navigate('/panel_avance');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;

        if (type === 'file') {
            const file = (e.target as HTMLInputElement).files?.[0] ?? null;

            setFormDataEvidencia(prev => ({
                ...prev,
                [name]: file,
            }));
            const input = e.target as HTMLInputElement;
            if (file) {
                setArchivo(file);
                setPreviewImage(URL.createObjectURL(file));
            }
            /*if (file) {
                setPreviewImage(URL.createObjectURL(file));
            }*/
        } else {
            setFormDataEvidencia(prev => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    useEffect(() => {

        fetch('https://apis.grupobrame.com/heroes/api/evidencias', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ correo: usuario.correo })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) setEvidencias(data.evidencias);

            })
            .catch(err => console.error(err));

        fetch('https://apis.grupobrame.com/heroes/api/evidencias_sumas', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ correo: usuario.correo })
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) setEvidenciasSumas(data.evidencias_sumas);
                setLoading(false);

            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });

    }, []);

    const subirEvidencia = async (e: React.FormEvent) => {
        e.preventDefault();
        setSubiendo(true);
        try {
            console.log(JSON.stringify(formDataEvidencia, null, 2));
            console.log(JSON.stringify(usuario, null, 2));

            if (!archivo) {
                alert("Por favor selecciona una imagen.");
                return;
            }

            const formDataImage = new FormData();
            formDataImage.append("imagen", archivo);
            console.log(archivo);
            console.log(formDataEvidencia);

            try {
                const res = await fetch("https://apis.grupobrame.com/heroes/api/subir_imagen", {
                    method: "POST",
                    body: formDataImage,
                });

                const result = await res.json();
                if (result.success) {
                    const imagenPath = result.path;
                    setRutaImagen(imagenPath); // (opcional, por si necesitas mostrarlo en UI)
                    formDataEvidencia.ruta_archivo = imagenPath;
                } else {
                    alert("Error al subir la imagen: " + result.message);
                }
            } catch (error) {
                console.error("Error al subir:", error);
                alert("Error al subir la imagen");
            }

            try {
                const evidencia_arriba = await fetch("https://apis.grupobrame.com/heroes/api/subir_evidencia", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        tipo_ejercicio_evidencia: formDataEvidencia.tipo_ejercicio_evidencia,
                        calorias_quemadas_evidencia: formDataEvidencia.calorias_quemadas_evidencia,
                        tiempo_evidencia: formDataEvidencia.tiempo_evidencia,
                        pasos_evidencia: formDataEvidencia.pasos_evidencia,
                        distancia_evidencia: formDataEvidencia.distancia_evidencia,
                        correo_evidencia: usuario.correo,
                        ruta_archivo: formDataEvidencia.ruta_archivo,
                    })
                });

                const response_evidencia = await evidencia_arriba.json();
                if (response_evidencia.success) {
                    alert("Evidencia subida correctamente");
                    setUploadModalOpen(false);
                    window.location.reload();
                } else {
                    alert(response_evidencia.message);
                }
            } catch (error) {
                console.error("Error al subir evidencia", error);
                alert("Error al subir la evidencia. Intenta más tarde.")
            }
        } finally {
            setSubiendo(false);
        }
    }

    if (loading) {
      return (
        <div className="flex h-screen w-full flex-col items-center justify-center bg-white space-y-4">
          <img
            src={require('../img/race.gif')}
            alt="Cargando"
            className="h-32 w-32"
          />
          <div className="text-center text-lg font-medium text-gray-700 animate-pulse">
            Cargando tu progreso...
          </div>
        </div>
      );
    }

    return (
        <div>
            {/*JSON.stringify(usuario, null, 2)*/}
            {/********************************/}
                <div className="min-h-full">
                    <Disclosure as="nav" className="border-b border-gray-200 bg-gray-100">
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <div className="flex h-16 justify-between">
                                <div className="flex">
                                    <div className="flex shrink-0 items-center">
                                        <img
                                            alt="Your Company"
                                            src="https://administraciontigb-grupobrameodoosh1.odoo.com/web/image/website/1/favicon?unique=304a711"
                                            className="block h-8 w-auto lg:hidden"
                                        />
                                        <img
                                            alt="Your Company"
                                            src="https://administraciontigb-grupobrameodoosh1.odoo.com/web/image/website/1/favicon?unique=304a711"
                                            className="hidden h-8 w-auto lg:block"
                                        />
                                    </div>

                                </div>
                                <div className="ml-6 flex items-center">
                                    {/* Profile dropdown */}
                                    <Menu as="div" className="relative ml-3">
                                        <div>
                                            <MenuButton className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-hidden focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2">
                                                <span className="absolute -inset-1.5" />
                                                <span className="sr-only">Menú Usuario</span>

                                                {usuario.avatar_perfil ? (
                                                    <img
                                                        src={'https://apis.grupobrame.com/heroes/'+usuario.avatar_perfil}
                                                        alt="Avatar"
                                                        className="size-8 rounded-full"
                                                    />
                                                ) : (
                                                    <img
                                                        src="https://apis.grupobrame.com/heroes/img/perfil/default_avatar.jpeg"
                                                        alt="Avatar por defecto"
                                                        className="size-8 rounded-full"
                                                    />
                                                )}
                                            </MenuButton>
                                        </div>
                                        <MenuItems
                                            transition
                                            className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                                        >


                                            {usuario.capitan !== null && (
                                                <MenuItem key="Perfil">
                                                    <a
                                                        onClick={revisarEvidencias}
                                                        className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                                                    >
                                                        Revisar Evidencias
                                                    </a>
                                                </MenuItem>
                                            )}
                                            <MenuItem key="Cerrar Sesión">
                                                <a
                                                    onClick={cerrarSesion}
                                                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                                                >
                                                    Cerrar Sesión
                                                </a>
                                            </MenuItem>

                                        </MenuItems>
                                    </Menu>
                                    <div className="ml-3">
                                        <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                            {usuario.nombre?.charAt(0).toUpperCase() + usuario.nombre?.slice(1)} {usuario.apellido?.charAt(0).toUpperCase() + usuario.apellido?.slice(1)}
                                        </p>
                                        <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">{usuario.correo}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Disclosure>

                    <div className="py-10">
                        <header>
                            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                                <h1 className="text-3xl font-bold tracking-tight text-gray-900">Mi Progreso</h1>
                                <div className="flex justify-center sm:justify-end mt-4">
                                  <button
                                    onClick={() => setUploadModalOpen(true)}
                                    className="rounded-lg bg-orange-500 px-4 py-2 text-white hover:bg-orange-600"
                                  >
                                    Subir Evidencia
                                  </button>
                                </div>
                            </div>
                        </header>
                        <main>

                            <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                                <h3 className="text-base font-semibold text-gray-900"></h3>
                                <dl className="mt-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm md:grid-cols-3 md:divide-x md:divide-y-0">
                                  <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Total de Calorías</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                      <div className="flex items-baseline text-2xl font-semibold text-orange-600">
                                        {evidenciasSumas[0]?.total_calorias ?? 0}
                                        <span className="ml-2 text-sm font-medium text-gray-500">cal</span>
                                      </div>
                                    </dd>
                                  </div>
                                  <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Total de Horas</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                      <div className="flex items-baseline text-2xl font-semibold text-blue-600">
                                          { ((evidenciasSumas[0]?.total_tiempo ?? 0) / 60).toFixed(2) }
                                        <span className="ml-2 text-sm font-medium text-gray-500">hrs</span>
                                      </div>
                                    </dd>
                                  </div>
                                  <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Distancia y Pasos</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                      <div className="flex flex-col text-xl font-semibold text-green-600">
                                        <div>{evidenciasSumas[0]?.total_distancia ?? 0} <span className="ml-1 text-sm font-medium text-gray-500">km</span></div>
                                        <div>{evidenciasSumas[0]?.total_pasos ?? 0} <span className="ml-1 text-sm font-medium text-gray-500">pasos</span></div>
                                      </div>
                                    </dd>
                                  </div>
                                </dl>
                            </div>


                            <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                              <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                                {evidencias.map((item, index) => (
                                  <li key={index} className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow-sm">
                                    <div className="flex flex-1 flex-col p-8">
                                      <h2 className="mt-1 text-lg font-medium text-gray-900">
                                        {new Date(item.created_at).toLocaleDateString('es-MX', {
                                          day: '2-digit',
                                          month: 'long',
                                          year: 'numeric'
                                        })}
                                      </h2>
                                      <dl className="mt-3 flex grow flex-col justify-between">
                                        <dd className="text-lgtext-gray-500">{item.tipo_ejercicio_evidencia?.charAt(0).toUpperCase() + item.tipo_ejercicio_evidencia?.slice(1)}</dd>
                                        <dd className="text-sm text-gray-500">{item.tiempo_ejercicio} min / {item.calorias_quemadas} cal</dd>
                                        <dd className="text-sm text-gray-500">Pasos: {item.pasos}</dd>
                                        <dd className="text-sm text-gray-500">Distancia: {item.distancia_km} km</dd>
                                          <span
                                            className={
                                              "mt-4 shrink-0 items-center rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset " +
                                              (item.estatus === "Invalido"
                                                ? "bg-red-50 text-red-700 ring-red-600/20"
                                                : item.estatus === "En Revisión"
                                                ? "bg-orange-50 text-orange-700 ring-orange-600/20"
                                                : "bg-green-50 text-green-700 ring-green-600/20")
                                            }
                                          >
                                            {item.estatus}
                                          </span>
                                        <dd className="text-sm text-gray-500 p-4 m-4">
                                            <img src={'https://apis.grupobrame.com/heroes/'+item.imagen_path} alt="" className="aspect-square w-full rounded-xl object-cover" onClick={() => modalImage('https://apis.grupobrame.com/heroes/'+item.imagen_path)}/>
                                        </dd>

                                      </dl>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} className="fixed inset-0 z-50 bg-black/80">
                              <div className="flex h-full w-full items-center justify-center" onClick={() => setIsModalOpen(false)}>
                                <Dialog.Panel
                                  className="relative w-full max-w-xl mx-4 rounded-lg bg-white p-6 shadow-xl sm:mx-0 sm:p-10"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <button
                                    onClick={() => setIsModalOpen(false)}
                                    className="absolute top-2 right-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-orange-400 text-white text-xl font-bold hover:bg-orange-500"
                                    aria-label="Cerrar"
                                  >
                                    &times;
                                  </button>
                                  <img
                                    src={modalImageSrc}
                                    alt="Evidencia Modal Mod"
                                    className="max-h-screen max-w-full rounded-lg cursor-pointer"
                                    onClick={() => setIsModalOpen(false)}
                                  />
                                </Dialog.Panel>
                              </div>
                            </Dialog>
                            <Dialog open={uploadModalOpen} onClose={() => setUploadModalOpen(false)} className="fixed inset-0 z-50 bg-black/80">
                              <div className="flex h-full w-full items-center justify-center" onClick={() => setUploadModalOpen(false)}>
                                <Dialog.Panel className="relative w-full max-w-xl max-h-[90vh] overflow-x-auto mx-4 bg-white p-6 rounded shadow" onClick={(e) => e.stopPropagation()}>
                                  <h2 className="text-xl font-semibold mb-4">Nueva Evidencia</h2>
                                    <form onSubmit={subirEvidencia} className="space-y-4">
                                        <div className="sm:col-span-3 col-span-6">
                                            <label htmlFor="tipo_ejercicio_evidencia"
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Tipo de Ejercicio
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="tipo_ejercicio_evidencia"
                                                    name="tipo_ejercicio_evidencia"
                                                    type="text"
                                                    value={formDataEvidencia.tipo_ejercicio_evidencia}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="Nadar, Correr, Gym, Yoga"
                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                                />
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3 col-span-6">
                                            <label htmlFor="calorias_quemadas_evidencia"
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Calorías Quemadas
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="calorias_quemadas_evidencia"
                                                    name="calorias_quemadas_evidencia"
                                                    type="number"
                                                    value={formDataEvidencia.calorias_quemadas_evidencia}
                                                    onChange={handleChange}
                                                    required
                                                    placeholder="300"
                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                                />
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3 col-span-6">
                                            <label htmlFor="tiempo_evidencia"
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Tiempo de Actividad en Minutos
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="tiempo_evidencia"
                                                    name="tiempo_evidencia"
                                                    type="number"
                                                    value={formDataEvidencia.tiempo_evidencia}
                                                    onChange={handleChange}
                                                    placeholder="20"
                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                                />
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3 col-span-6">
                                            <label htmlFor="pasos_evidencia"
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Numero de Pasos
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="pasos_evidencia"
                                                    name="pasos_evidencia"
                                                    type="number"
                                                    value={formDataEvidencia.pasos_evidencia}
                                                    onChange={handleChange}
                                                    placeholder="240"
                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                                />
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3 col-span-6">
                                            <label htmlFor="distancia_evidencia"
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Distancia Recorrida en Km
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    id="distancia_evidencia"
                                                    name="distancia_evidencia"
                                                    type="number"
                                                    value={formDataEvidencia.distancia_evidencia}
                                                    onChange={handleChange}
                                                    placeholder="1.2"
                                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                                />
                                            </div>
                                        </div>

                                        <div className="sm:col-span-3 col-span-6">
                                            <label
                                                   className="block text-sm/6 font-medium text-gray-900">
                                                Imagen de Evidencia
                                            </label>
                                            <div className="mt-2">
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    className="file:mr-4 file:rounded-lg file:border-0 file:bg-orange-400 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-orange-500"
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        {previewImage && (
                                            <div className="mt-4">
                                                <img
                                                    src={previewImage}
                                                    alt="Vista previa de la evidencia"
                                                    className="aspect-square w-full rounded-xl object-cover"
                                                />
                                            </div>
                                        )}

                                        {/*<dl className="mt-3 flex grow flex-col justify-between">
                                            <dd className="text-sm text-gray-500 p-4 m-4">
                                                <img alt="" className="aspect-square w-full rounded-xl object-cover"/>
                                            </dd>

                                        </dl>*/}


                                        <div className="text-right">
                                            {subiendo ? (
                                                <button
                                                    type="button"
                                                    className="rounded bg-gray-400 px-4 py-2 text-white flex items-center"
                                                    disabled
                                                >
                                                    <img
                                                        src={require('../img/race.gif')}
                                                        alt="Subiendo..."
                                                        className="h-5 w-5 mr-2"
                                                    />
                                                    Subiendo...
                                                </button>
                                            ) : (
                                                <button
                                                    type="submit"
                                                    className="rounded bg-orange-500 px-4 py-2 text-white hover:bg-orange-600"
                                                >
                                                    Enviar
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </Dialog.Panel>
                              </div>
                            </Dialog>
                        </main>
                    </div>
                </div>
            {/********************************/}
        </div>
    );
}

export default UserViewComponent;